__turbopack_context__.v({
  "countryCode": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__countryCode",
  "darkBg": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__darkBg",
  "darkMode": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__darkMode",
  "darkText": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__darkText",
  "darkspecific": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__darkspecific",
  "disabled": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__disabled",
  "dropdown": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__dropdown",
  "dropdownIcon": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__dropdownIcon",
  "dropdownItem": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__dropdownItem",
  "dropdownMenu": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__dropdownMenu",
  "dropdownMenuWrapper": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__dropdownMenuWrapper",
  "dropdownToggle": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__dropdownToggle",
  "dropdownToggleCountryCode": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__dropdownToggleCountryCode",
  "liContainer": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__liContainer",
  "referralCountryCodeDropdown": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__referralCountryCodeDropdown",
  "scrollArrow": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__scrollArrow",
  "spanWidth": "CustomDropdownGlobal-module-scss-module__WWQ_Oq__spanWidth",
});
